// Module
var code = "<div class=\"curve-graph\" data-bind=\"if: highchartsOptions\">\n    <div data-bind=\"highcharts: {options: highchartsOptions, chart: chart}\" class=\"chart\"></div>\n</div>\n";
// Exports
module.exports = code;